export default __webpack_public_path__ + "static/media/vid13.4cea9257.mp4";